// removed by extract-text-webpack-plugin
module.exports = {"Main":"Home__Main__3e2HR","Home":"Home__Home__3pDxK","Animation":"Home__Animation__2ZCHE","DivButton":"Home__DivButton__npwel","DivMouse":"Home__DivMouse__2jaLx","Text":"Home__Text__1s4cD","Content":"Home__Content__1-9wX","Container":"Home__Container__2c6lK","ColorWhite":"Home__ColorWhite__3PbaA"};


//////////////////
// WEBPACK FOOTER
// ./client/src/containers/Home/Home.css
// module id = 338
// module chunks = 0